import * as React from "react";

import { Tab } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { OhCaseTasksTimeline } from "./OhCaseTasksTimeline";

interface Props {
    tasks: TaskModel[];
    customerId: string;
}

export const OhCaseTasks: React.FC<Props> = (props: Props) => {
    const completedTasks = props.tasks.filter(t => t.completed || t.cancelled);
    const openTasks = props.tasks.filter(t => !t.completed && !t.cancelled);
    return (
        <Tab panes={[
            { menuItem: "Open Tasks", render: () => <OhCaseTasksTimeline tasks={openTasks} customerId={props.customerId} /> },
            { menuItem: "Completed Tasks", render: () => <OhCaseTasksTimeline tasks={completedTasks} customerId={props.customerId} /> },
        ]} />
    );
};
